import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const DocusignPreschools = Loadable({
  loader: () => import("./components/docusignPreschools"),
  loading: Loading,
});

export const routes = [
  {
    path: "/docusignPreschools",
    exact: true,
    name: "docusignPreschools",
    component: DocusignPreschools,
  },
];